import React from 'react';

import { Wallet, Lock, Gift, ArrowUpRight, TrendingUp } from 'lucide-react';

interface WalletBalanceCardsProps {
  currency: string;
  symbol: string;
}

export default function WalletBalanceCards({ symbol }: WalletBalanceCardsProps) {
  const cards = [
    {
      id: 'wbc-available',
      label: 'Available Balance',
      value: `${symbol}124.50`,
      sublabel: 'Ready to use',
      icon: Wallet,
      cardClass: 'wallet-card-available',
      iconColor: '#A78BFA',
      trend: '+$45 today',
      trendColor: '#10B981',
    },
    {
      id: 'wbc-locked',
      label: 'Locked in Competitions',
      value: `${symbol}30.00`,
      sublabel: '3 active competitions',
      icon: Lock,
      cardClass: 'wallet-card-locked',
      iconColor: '#F59E0B',
      trend: 'Releasing after results',
      trendColor: '#F59E0B',
    },
    {
      id: 'wbc-bonus',
      label: 'Bonus Balance',
      value: `${symbol}15.00`,
      sublabel: 'Competition use only',
      icon: Gift,
      cardClass: 'wallet-card-bonus',
      iconColor: '#06B6D4',
      trend: 'Expires in 14 days',
      trendColor: '#94A3B8',
    },
    {
      id: 'wbc-withdrawable',
      label: 'Withdrawable Balance',
      value: `${symbol}109.50`,
      sublabel: 'After verification',
      icon: ArrowUpRight,
      cardClass: 'wallet-card-withdrawable',
      iconColor: '#10B981',
      trend: 'KYC verified ✓',
      trendColor: '#10B981',
    },
  ];

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div key={card.id} className={`rounded-xl p-4 ${card.cardClass}`}>
          <div className="flex items-start justify-between mb-3">
            <div className="w-9 h-9 rounded-xl flex items-center justify-center"
              style={{ background: `${card.iconColor}20` }}>
              <card.icon size={18} style={{ color: card.iconColor }} />
            </div>
            <TrendingUp size={14} style={{ color: card.iconColor, opacity: 0.6 }} />
          </div>
          <p className="metric-label mb-1">{card.label}</p>
          <p className="text-2xl font-extrabold text-foreground mb-1" style={{ fontVariantNumeric: 'tabular-nums' }}>
            {card.value}
          </p>
          <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>{card.sublabel}</p>
          <p className="text-xs mt-2 font-semibold" style={{ color: card.trendColor }}>{card.trend}</p>
        </div>
      ))}
    </div>
  );
}